import React from "react";
import ReactDOM from "react-dom";
// Our modules
import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));
